import React from 'react';
const AppContainer = (props) => {
    return (React.createElement("div", { id: "app_container", "data-testid": "app_container" }, props.children));
};
export default AppContainer;
